export const months =[
    "jan","feb","mar","apr","may","jun","jul","aug","sep","oct","nov","dec"
]

export const termMonths: { [key: number]: string[] } = {
    1: ["jan", "feb", "mar"],
    2: ["apr", "may", "jun"],
    3: ["jul", "aug", "sep"],
    4: ["oct", "nov", "dec"],
  };